import React, { useState } from 'react';
import './QuestionDisplay.css';
import logos from '../../../assets/images/loghi/logos.svg';
import FillTextQuestion from './FillTextQuestion.js';
import Modal from '../../_Components/Modal';
import { QuestionMarkIcon, TripleDotsIcons } from '../../../components/Icons';

const QuestionDisplay = ({
  question,
  questionNumber,
  selectedAnswer,
  textAnswer,
  onAnswerSelect,
  onTextChange,
  onSubmitAnswer,
  isSubmitting = false,
  showSkipOption = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);


  console.log('🔘 Question:', question);
  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if answer is provided based on question type
    const hasAnswer =
      question.type === 'standard'
        ? selectedAnswer !== null
        : question.type === 'fill_text'
          ? textAnswer.trim() !== ''
          : false; // Handle other question types as needed

    if (hasAnswer) {
      onSubmitAnswer();
    } else if (showSkipOption) {
      setIsModalOpen(true);
    }
  };

  const handleAnswerSelect = (index) => {
    if (selectedAnswer === index) {
      onAnswerSelect(null);
    } else {
      onAnswerSelect(index);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const renderQuestionContent = () => {
    // Handle fill-in-the-blank questions
    if (question.type === 'fill_text') {
      return (
        <FillTextQuestion
          question={question}
          textAnswer={textAnswer}
          onTextChange={onTextChange}
          onSubmitAnswer={handleSubmit}
          isSubmitting={isSubmitting}
        />
      );
    }

    return (
      <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} className='quiz-form'>
        <div className='answers-container'>
          {question.answers?.map((answer, index) => (
            <label
              key={index}
              className={`answer-option ${selectedAnswer === index ? 'selected' : ''
                } ${isSubmitting ? 'disabled' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                if (!isSubmitting) {
                  handleAnswerSelect(index);
                }
              }}
            >
              <input
                type='radio'
                name='answer'
                value={index}
                checked={selectedAnswer === index}
                onChange={() => {}} 
                disabled={isSubmitting}
                className='answer-input'
                onClick={(e) => e.stopPropagation()} 
              />
              <span className='answer-text'>{answer}</span>
              <span className='answer-radio'>
                <div
                  className={`radio-circle ${selectedAnswer === index ? 'selected' : ''
                    }`}
                ></div>
              </span>
            </label>
          ))}
        </div>

        <div className='submit-container'>
          <button
            type='submit'
            disabled={isSubmitting}
            className={isSubmitting ? 'submitting' : ''}
          >
            {console.log('🔘 Submit button state:', {
              isSubmitting: isSubmitting,
              disabled: isSubmitting,
              className: isSubmitting ? 'submitting' : '',
            })}
            {isSubmitting ? 'Invio in corso...' : 'Invia risposta'}
          </button>
        </div>
      </form>
    );
  };

  return (
    <div className='question-display'>
      <div className='question-header'>
        <div className='logo-container'>
          <img
            src={logos}
            width={284}
            height={40}
            alt='Sponsor Logos'
          />
        </div>

        <div className='question-info'>
          <div className='question-number'>
            Domanda {questionNumber + 1}
          </div>
        </div>

        <h2 className='question-text'>
          {question.text.split(/\[:blank:\]/).map((part, index, array) => (
            <React.Fragment key={index}>
              {part}
              {index < array.length - 1 && (
                <span className="fill-blank" data-blank={index + 1} style={{
                  marginLeft: '10px', marginRight: '10px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  verticalAlign: 'top'
                }}>
                  <TripleDotsIcons width={30} height={38} style={{
                    verticalAlign: 'top',
                    display: 'inline-block',
                    transform: 'translateY(-2px)'
                  }} />
                </span>
              )}
            </React.Fragment>
          ))}
        </h2>

      </div>

      {renderQuestionContent()}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className='modal-icon'>
          <QuestionMarkIcon />
        </div>

        <div className='modal-content-text'>
          <h2 className='modal-title'>Non hai risposto alla domanda</h2>
          <p className='modal-subtitle'>
            Se scegli di proseguire senza rispondere, la domanda verrà segnata
            come omessa
          </p>
        </div>

        <div className='modal-buttons'>
          <button
            onClick={() => {
              setIsModalOpen(false);
              onSubmitAnswer(true);
            }}
          >
            Continua senza risposta
          </button>

          <button
            className='button-secondary'
            onClick={() => setIsModalOpen(false)}
          >
            Annulla e rispondi
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default QuestionDisplay;
